import { CareTreatmentSection } from "@/features/patient/care-treatment/components/CareTreatmentView";
import { useCareTreatment } from "@/features/patient/care-treatment/utils/adaptCareTreatment";

export function CareTreatmentPage() {
  const { encounters, notes, plans, providers, isLoading } = useCareTreatment();
  return (
    <CareTreatmentSection
      encounters={encounters}
      notes={notes}
      plans={plans}
      providers={providers}
      isLoading={isLoading}
    />
  );
}
